import { apiInterface } from '@/api/interfaces'
import AbstractApi from '@/api/abstract'
import qs from 'qs'
import { tariffApiReq, tariffApiRes } from './interfaces'

const LIMIT = 100

class TariffApi implements apiInterface.ITariffApi {
  ctx: AbstractApi

  constructor(ctx: AbstractApi) {
    this.ctx = ctx
  }

  getTariffs = async (
    params: tariffApiReq.IGetTariffsReq = {}
  ): Promise<tariffApiRes.IGetTariffsRes> => {
    const res = await this.ctx.get<tariffApiReq.IGetTariffsReq, tariffApiRes.IGetTariffsRes>(
      '/tariff/',
      {
        limit: LIMIT,
        ...params
      }
    )
    return res.data
  }

  getTariff = async (id: number): Promise<tariffApiRes.IGetTariffRes> => {
    const res = await this.ctx.get<unknown, tariffApiRes.IGetTariffRes>(`/tariff/${id}/`)
    return res.data
  }

  getActualTariff = async (
    params: tariffApiReq.IGetActualTariffReq
  ): Promise<tariffApiRes.IGetActualTariffRes> => {
    const res = await this.ctx.get<
      tariffApiReq.IGetActualTariffReq,
      tariffApiRes.IGetActualTariffRes
    >('/tariff/actual_tariffs/', params)
    return res.data
  }

  getDepositListPattern = async (
    params: tariffApiReq.IGetDepositListPatternReq
  ): Promise<tariffApiRes.IGetDepositListPatternRes> => {
    const res = await this.ctx.get<
      tariffApiReq.IGetDepositListPatternReq,
      tariffApiRes.IGetDepositListPatternRes
    >('/tariff/deposit_list', params)
    return res.data
  }

  depositOrdersCheck = async (
    id: number,
    params: tariffApiReq.IDepositOrdersCheckReq
  ): Promise<number[]> => {
    const res = await this.ctx.get<tariffApiReq.IDepositOrdersCheckReq, number[]>(
      `/tariff/orders_check/deposit/${id}/`,
      {},
      {
        params,
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'comma' })
      }
    )
    return res.data
  }

  certificateOrdersCheck = async (
    id: number,
    params: tariffApiReq.ICertificateOrdersCheckReq
  ): Promise<number[]> => {
    const res = await this.ctx.get<tariffApiReq.ICertificateOrdersCheckReq, number[]>(
      `/tariff/orders_check/certificate/${id}/`,
      {},
      {
        params,
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'comma' })
      }
    )
    return res.data
  }

  getRatesList = async (
    params: tariffApiReq.IGetRatesListReq
  ): Promise<tariffApiRes.IGetRatesListRes> => {
    const res = await this.ctx.get<tariffApiReq.IGetRatesListReq, tariffApiRes.IGetRatesListRes>(
      '/tariff/rates_list/',
      params
    )
    return res.data
  }

  checkAutomaticStock = async (
    params: tariffApiReq.ICheckManualAutomaticReq
  ): Promise<tariffApiRes.ICheckManualAutomaticRes[]> => {
    const res = await this.ctx.post<
      tariffApiReq.ICheckManualAutomaticReq,
      tariffApiRes.ICheckManualAutomaticRes[]
    >('/tariff/stock/automatic_stock_check_staff/', params)
    return res.data
  }

  checkManualStock = async (
    params: tariffApiReq.ICheckManualStockReq
  ): Promise<tariffApiRes.ICheckManualStockRes[]> => {
    const res = await this.ctx.post<
      tariffApiReq.ICheckManualStockReq,
      tariffApiRes.ICheckManualStockRes[]
    >('/tariff/stock/manual_stock_check_staff/', params)
    return res.data
  }

  getManualStock = async (
    params: tariffApiReq.IGetManualStockReq
  ): Promise<tariffApiRes.IGetManualStockRes[]> => {
    const res = await this.ctx.get<
      tariffApiReq.IGetManualStockReq,
      tariffApiRes.IGetManualStockRes[]
    >('/tariff/stock/manual_stock_list', params)
    return res.data
  }

  checkPromoCode = async (
    params: tariffApiReq.ICheckPromoCodeReq
  ): Promise<tariffApiRes.ICheckPromoCodeRes[]> => {
    const res = await this.ctx.post<
      tariffApiReq.ICheckPromoCodeReq,
      tariffApiRes.ICheckPromoCodeRes[]
    >('/tariff/stock/promo_stock_check_staff/', params)
    return res.data
  }

  extendDeposit = async (depositId: number): Promise<void> => {
    const res = await this.ctx.post<unknown, void>(`/tariff/deposit/${depositId}/extend/`, {})
    return res.data
  }

  createAutogenerationTariff = async (
    data: tariffApiReq.ICreateAutogenerationTariffReq
  ): Promise<void> => {
    const res = await this.ctx.post<tariffApiReq.ICreateAutogenerationTariffReq, void>(
      '/tariff/tariff/autogeneration/',
      data
    )
    return res.data
  }

  getAutogenerationTariffs = async (
    page: number = 1
  ): Promise<tariffApiRes.IGetAutogenerationTariffsRes> => {
    const res = await this.ctx.get<unknown, tariffApiRes.IGetAutogenerationTariffsRes>(
      '/tariff/tariff/autogeneration/list/',
      { page }
    )
    return res.data
  }
}

export default TariffApi
